import { FC, PropsWithChildren } from 'react';

import Unauthorised from './Unauthorised';

import { useKeycloakAuth } from '../hooks';
import { MembershipType } from '../types';

type Props = {
    isAuthenticated: boolean;
    allowedMemberships?: MembershipType[];
};

const AuthGate: FC<PropsWithChildren<Props>> = ({
    isAuthenticated,
    allowedMemberships,
    children,
}) => {
    const { user, logout } = useKeycloakAuth();

    // Only check for user if we're authenticated
    // E.g. MH users can access the site without authentication
    if (!user && isAuthenticated) {
        return;
    }

    const userMembership = user?.memberships[0].m_type || null;

    if (
        allowedMemberships &&
        userMembership &&
        ![...allowedMemberships, MembershipType.ADMIN].includes(userMembership)
    ) {
        return <Unauthorised logout={logout} />;
    }

    return children;
};

export default AuthGate;
